const canadaFeatures = [
  { icon: "ri-truck-line", title: "3-6 Day Delivery", desc: "Fast shipping across all Canadian provinces and territories." },
  { icon: "ri-shield-check-line", title: "Duties Included", desc: "All import duties pre-paid. Transparent pricing for your customers." },
  { icon: "ri-translate-2", title: "Bilingual Support", desc: "Full English and French support for Quebec and all provinces." },
  { icon: "ri-money-dollar-circle-line", title: "USD &amp; CAD Pricing", desc: "Accept payments in both US and Canadian dollars seamlessly." },
  { icon: "ri-map-pin-line", title: "Key Locations", desc: "Warehouses in Toronto, Vancouver, Montreal, and Calgary." },
  { icon: "ri-leaf-line", title: "Eco-Friendly Packaging", desc: "Sustainable packaging options to meet Canadian environmental standards." },
];

const canadaStats = [
  { value: "4", label: "Warehouse Locations" },
  { value: "35K+", label: "Products in Stock" },
  { value: "3-6", label: "Days Delivery" },
  { value: "98.8%", label: "Order Accuracy" },
];

const CanadaWarehouseSection = () => (
  <section id="canada-warehouse" className="py-16 bg-[#8B0000]">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="flex flex-col lg:flex-row-reverse gap-12 items-center">
        {/* Right Content */}
        <div className="lg:w-1/2">
          <div className="flex items-center gap-3 mb-4">
            <span className="text-5xl">🇨🇦</span>
            <div>
              <div className="text-[#D4AF37] text-sm font-semibold uppercase tracking-wider">Local Fulfillment</div>
              <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight">
                Canada Warehouse Dropshipping
              </h2>
            </div>
          </div>
          <p className="text-white/80 text-sm mb-8 leading-relaxed">
            Serve Canadian customers with lightning-fast local delivery. Our Canada-based warehouses ensure your products arrive quickly with full bilingual support in English and French.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
            {canadaStats.map((stat) => (
              <div key={stat.label} className="bg-white/10 rounded-lg p-4 text-center">
                <div className="text-2xl font-extrabold text-[#D4AF37]">{stat.value}</div>
                <div className="text-white/70 text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            {canadaFeatures.map((f) => (
              <div key={f.title} className="flex gap-3 items-start">
                <div className="w-8 h-8 flex items-center justify-center bg-[#D4AF37]/20 rounded-lg flex-shrink-0">
                  <i className={`${f.icon} text-[#D4AF37]`}></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">{f.title}</div>
                  <div className="text-white/60 text-xs mt-0.5" dangerouslySetInnerHTML={{ __html: f.desc }} />
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-3">
            <a
              href="https://wa.me/1234567890"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-[#25D366] text-white px-5 py-3 rounded-full font-semibold text-sm hover:bg-[#1ebe5d] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i> Contact via WhatsApp
            </a>
            <button className="flex items-center gap-2 bg-white text-[#8B0000] px-5 py-3 rounded-full font-semibold text-sm hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-store-2-line"></i> Start Dropshipping
            </button>
          </div>
        </div>

        {/* Left Image */}
        <div className="lg:w-1/2">
          <div className="relative rounded-lg overflow-hidden h-80 md:h-[420px]">
            <img
              src="https://public.readdy.ai/ai/img_res/b23a03b72a513844d8f562bad581de6b.jpg"
              alt="Canada Warehouse"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#8B0000]/60 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <div className="bg-white/95 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-xs font-bold text-gray-800">Live Inventory Status / Statut en direct</span>
                </div>
                <div className="grid grid-cols-3 gap-2 text-center">
                  <div>
                    <div className="text-sm font-bold text-[#8B0000]">9,820</div>
                    <div className="text-[10px] text-gray-500">Items in Stock</div>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-[#8B0000]">218</div>
                    <div className="text-[10px] text-gray-500">Orders Today</div>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-[#8B0000]">98.8%</div>
                    <div className="text-[10px] text-gray-500">On-Time Rate</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default CanadaWarehouseSection;
